<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách đối soát</h1>
      <div class="float-right btn-group sm-float-none">
        <button
          class="font-medium f12 btn btn-outline-secondary"
          v-show="selected.length > 0"
          @click="updateStatus"
        >
          <i class="bx bx-pencil"></i> Cập nhật đã thu tiền
        </button>
        <router-link class="f12 font-medium btn btn-outline-secondary" :to="`/list-receipts`">
          <i class="bx bx-arrow-back"></i> Quay lại
        </router-link>
      </div>
    </div>

    <div class="card p-10 pt-15 b-t-1-869fb229">
      <VueLoadingOverlay :active.sync="loading" :is-full-page="true"> </VueLoadingOverlay>

      <div class="card-header m-b-10">
        <div class="float-left w-auto box-search bs-left">
          <form class="box-search">
            <div class="form-group">
              <InputRangeRaw
                v-model="createdDateRange"
                placeholder="Thời gian tạo phiếu thu"
                clearable
                :max-date="new Date()"
              ></InputRangeRaw>
            </div>
            <p v-if="fileName" class="mt-2 mr-2"><b>Tên file: </b>{{ fileName }}</p>
            <div class="form-group">
              <input
                style="display: none"
                ref="uploadFileExcel"
                @change="uploadFileExcel"
                type="file"
              />
              <a
                href="#"
                class="pt-2 btn btn-primary hc-37 m-b-10"
                data-toggle="tooltip"
                data-placement="top"
                @click="importFile"
                >Chọn file tải lên</a
              >
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="card p-10 pt-15 b-t-1-869fb229">
      <b-table :items="dataTable" :fields="fields" responsive="sm">
        <template #thead-top>
          <b-tr>
            <b-th variant="" colspan="1"></b-th>
            <b-th variant="primary" colspan="7">Thông tin phiếu thu</b-th>
            <b-th variant="success" colspan="4">Thông tin file đối soát</b-th>
          </b-tr>
        </template>
        <template #head(selected)>
          <input type="checkbox" v-model="selectAll" />
        </template>
        <template #cell(selected)="data">
          <input type="checkbox" v-model="selected" :value="data.item.receipt.receiptId" number />
        </template>
        <template #cell(timeUpload)="data">
          <!-- Why? hỏi Thảo tester nhé <3 -->
          <div v-if="data.item.upload && data.item.upload.time">
            {{ data.item.upload.time.split(' ')[1] + ', ' + data.item.upload.time.split(' ')[0] }}
          </div>
        </template>
        <template #cell(amountUpload)="data">
          {{ data.item.upload.amount | transformMoney }}
        </template>
        <template #cell(transactionCode)="data">
          {{ data.item.receipt.transactionCode }}
        </template>
        <template #cell(contentUpload)="data">
          {{ data.item.upload.content }}
        </template>
        <template #cell(paymentCodeUpload)="data">
          {{ data.item.upload.paymentCode }}
        </template>
        <template #cell(merchantInfo)="data">
          <p>
            <b>{{ data.item.receipt.merchantName }}</b>
          </p>
          <br />
          <p>{{ data.item.receipt.merchantMail }}</p>
          <br />
          <p class="text-primary">{{ data.item.receipt.merchantAddress }}</p>
        </template>
        <template #cell(createdDate)="data">
          <p>{{ data.item.receipt.createdDate | formatDate('HH:mm, DD/MM/YYYY') }}</p>
          <br />
        </template>
        <template #cell(serialNumber)="data">
          <p>{{ data.item.receipt.serialNumber }}</p>
        </template>
        <template #cell(amount)="data">
          <p>{{ data.item.receipt.amount | transformMoney }}</p>
        </template>
        <template #cell(receiptCode)="data">
          <p>{{ data.item.receipt.receiptCode }}</p>
        </template>
        <template #cell(receiptContractCode)="data">
          <p>{{ data.item.receipt.receiptContractCode }}</p>
        </template>
      </b-table>
    </div>

    <b-modal id="modal-scoped" v-model="notiModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <b-button variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <img :src="iconNoti" :alt="iconNoti" />
        <h2 class="py-3 f18">{{ msgNoti }}</h2>
      </div>
      <template #modal-footer="{ close }">
        <b-button variant="light" @click="$router.push('/list-receipts')" v-if="doneCompare">
          Đóng
        </b-button>
        <b-button variant="light" @click="close()" v-else> Đóng </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import { ReceiptService } from '@/services/receipts.service'
  import moment from 'moment'
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
  // import Config from '@/thirdParty/config'
  import InputRangeRaw from '../../components/InputRangeRaw.vue'
  export default {
    data() {
      return {
        loading: false,
        createdDateRange: null,
        messFailFormat: '',
        dataTable: [],
        fields: [
          { key: 'selected' },
          { key: 'receiptContractCode', label: 'Mã HĐ' },
          { key: 'receiptCode', label: 'Mã PT' },
          { key: 'transactionCode', label: 'Mã chứng từ' },
          { key: 'amount', label: 'Số tiền' },
          { key: 'serialNumber', label: 'Serial TB' },
          { key: 'createdDate', label: 'Thời gian' },
          { key: 'merchantInfo', label: 'Merchant' },
          { key: 'paymentCodeUpload', label: 'Mã chứng từ' },
          { key: 'contentUpload', label: 'Mô tả' },
          { key: 'amountUpload', label: 'Số tiền' },
          { key: 'timeUpload', label: 'Thời gian' },
        ],
        selected: [],
        notiModal: false,
        msgNoti: '',
        iconNoti: '',
        doneCompare: false,
        fileName: '',
      }
    },
    components: {
      InputRangeRaw,
    },
    computed: {
      selectAll: {
        get: function () {
          return this.dataTable ? this.selected.length === this.dataTable.length : false
        },
        set: function (value) {
          var selected = []
          if (value) {
            this.dataTable.forEach(function (item) {
              selected.push(item.receipt.receiptId)
            })
          }
          this.selected = selected
        },
      },
    },
    methods: {
      // upload
      importFile() {
        const fromDate = this.createdDateRange?.start ?? null
        const toDate = this.createdDateRange?.end ?? null
        if (fromDate == null || toDate == null) {
          this.showFailMx('Bắt buộc chọn thời gian tạo phiếu thu')
          return
        }
        if (moment(toDate).diff(moment(fromDate), 'd') >= 62) {
          this.showFailMx('Thời gian tạo phiếu thu được lọc tối đa 2 tháng')
          return
        }
        this.$refs.uploadFileExcel.click()
      },
      async uploadFileExcel(file) {
        this.fileName = null
        if (file.target.files.length === 0) return
        const allowedExtensions = /(\.xls|\.xlsx|\.csv|\.ods)$/i
        const checkFomat = allowedExtensions.exec(file.target.files[0].name)
        if (!checkFomat) {
          this.showFailMx('Định dạng không hợp lệ !')
          this.$refs.uploadFileExcel.value = null
          return
        }
        const fileData = file.target.files[0]
        if (fileData.size > 25 * 1024 * 1024) {
          this.showFailMx('File tối đa 25MB')
          return
        }
        this.fileName = file.target.files[0].name
        const formdata = new FormData()
        const fromDate = this.createdDateRange?.start ?? null
        const toDate = this.createdDateRange?.end ?? null
        formdata.append('file', file.target.files[0])
        formdata.append('fromDate', moment(fromDate).startOf('day').valueOf())
        formdata.append('toDate', moment(toDate).endOf('day').valueOf())
        this.submitUpload(formdata)
        this.$refs.uploadFileExcel.value = null
      },
      async updateStatus() {
        const flag = await this.approveMx('Bạn có chắc chắn muốn chuyển trạng thái Đã thu không?')
        if (!flag) {
          return
        }
        try {
          this.loading = true
          const data = await ReceiptService.updateStatusReceipts({
            transactionReqs: this.selected.map(s => {
              return {
                receiptId: s,
                transactionCode: this.dataTable.find(z => z.receipt.receiptId === s).upload
                  .paymentCode,
              }
            }),
          })
          if (data.code === 1000) {
            this.showSuccessMx(`Bạn đã duyệt ${this.selected.length} bản ghi thành công!`)
            this.doneCompare = true
          } else {
            this.errorMessage(data.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      errorMessage(msg) {
        this.notiModal = true
        this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
        this.msgNoti = msg
      },

      // upload
      async submitUpload(formData) {
        try {
          this.loading = true
          const res = await ReceiptService.importFileCompare(formData)
          if (res.code === 1000) {
            // console.log(123, res)
            this.loading = false
            const { listData } = res.data
            this.dataTable = listData ?? []
            // console.log(res.data)
            this.showMsgOk(res.data)
          } else {
            this.loading = false
            this.showFailMx(res.message)
          }
        } catch (e) {
          this.showFailMx(e.message)
        } finally {
          this.loading = false
        }
      },
      showMsgOk(data) {
        console.log(data)
        const h = this.$createElement
        // Using HTML string
        const titleVNode = h('div', {
          domProps: { innerHTML: 'Import file thành công' },
        })
        // More complex structure
        const messageVNode = h('div', { class: ['text-center'] }, [
          h('p', { class: ['text-center'] }, [
            'Số bản ghi thành công ',
            h('b', data.numberMatch),
            ' bản ghi',
          ]),
          h('p', { class: ['text-center'] }, [
            'Số bản ghi thất bại ',
            h('b', data.numberNoMatch),
            ' bản ghi',
          ]),
          data.numberNoMatch > 0 &&
            h(
              'button',
              {
                class: 'f12 font-medium btn btn-outline-danger',
                on: {
                  click: () => this.dowloadFileError(data.keyDownload),
                },
              },
              'Tải bản ghi thất bại'
            ),
        ])
        this.$bvModal.msgBoxOk([messageVNode], {
          title: [titleVNode],
          centered: true,
        })
      },
      async dowloadFileError(key) {
        if (!key) {
          this.showFailMx('Thiếu key download')
          return
        }
        try {
          this.loading = true
          const res = await ReceiptService.downloadReceiptCompareError({ key })
          console.log(333, res)
        } finally {
          this.loading = false
        }
      },
    },
  }
</script>

<style></style>
